<script>
  import { validateNamePattern } from "../../editor/utility.js";
  import { deviceTypes } from "../../editor/component/artboard.js";
  import { Collapse, Label, Input } from "sveltestrap";
  import {
    directContext,
    currMenu,
    viewSpecs,
    currentSpec,
    activeSpec,
  } from "../../editor/storage.js";

  import ItemResponse from "./ItemResponse.svelte";
  export let artboardSpec = {};
  export let mode;
  export let makeNewArtboard;
  export let updateArtboard;
  export let cancelSubMenu;
  export let unfindView;
  export let inputBlurAction;
  export let inputFocusAction;

  function checkName(name) {
    return validateNamePattern(name);
  }
  let invalidArtboardName = false;

  function setDefaultDeviceSize(event, reset) {
    let d = deviceTypes[event.target.value];
    artboardSpec.artboard_width = d.a_width;
    // todo
    if (lock_aspect_ratio && $viewSpecs[0]) {
      let ar =
        $viewSpecs[0].artboard.artboard_height /
        $viewSpecs[0].artboard.artboard_width;
      artboardSpec.artboard_height = Math.round(
        artboardSpec.artboard_width * ar
      );
    } else {
      artboardSpec.artboard_height = d.a_height;
    }
    artboardSpec.device_width = d.width;
    artboardSpec.device_height = d.height;
    artboardSpec.ppi = d.ppi;
  }
  function updateAspecRatio() {
    let d = deviceTypes[artboardSpec.screen_type];
    if (lock_aspect_ratio && $viewSpecs[0]) {
      let ar =
        $viewSpecs[0].artboard.artboard_height /
        $viewSpecs[0].artboard.artboard_width;
      artboardSpec.artboard_height = Math.round(
        artboardSpec.artboard_width * ar
      );
    } else {
      artboardSpec.artboard_height = d.a_height;
    }
  }

  let advanced = false;
  let lock_aspect_ratio = false;

  let isEligible = false;
  function checkEligibility() {
    return (
      checkName(artboardSpec.name) &&
      artboardSpec.name &&
      artboardSpec.screen_type &&
      artboardSpec.artboard_width &&
      artboardSpec.artboard_height &&
      artboardSpec.device_height &&
      artboardSpec.device_width &&
      artboardSpec.ppi
    );
  }
</script>

<div class="dupo-menu-pane mb-2">
  <div class="dupo-menu-pane-row mb-2">
    {#if mode === "new"}
      <h3 class="h-sub">Create a new responsive artboard</h3>
    {:else if mode === "edit"}
      <h3 class="h-sub">Edit "{$currentSpec.artboard.name}" artboard</h3>
    {/if}
  </div>
</div>

<!-- name, screen type, devie width, device height, artboard width, artboard height -->
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="text"
    token="artboard_name"
    title="Name"
    value={artboardSpec.name || ""}
    {inputBlurAction}
    {inputFocusAction}
    changeAction={(event) => {
      invalidArtboardName = !checkName(event.target.value);
      if (mode === "new") {
        artboardSpec.name = event.target.value;
      } else if (mode === "edit" && !invalidArtboardName) {
        updateArtboard(event, "name", $activeSpec);
      }
      isEligible = checkEligibility();
    }}
  />
  {#if invalidArtboardName}
    <div class="dupo-menu-pane-row warn-msg">
      <p class="text-sm">
        Invalid artboard name! Should use only 0-9, a-z, A-Z, -, and _.
      </p>
    </div>
  {/if}
</div>
<div class="dupo-menu-pane mb-2">
  <ItemResponse
    type="select"
    token="screen_type"
    title="Device type"
    value={artboardSpec.screen_type || ""}
    options={Object.keys(deviceTypes)}
    {inputBlurAction}
    {inputFocusAction}
    disabled={mode !== "new"}
    changeAction={(event) => {
      let reset = artboardSpec.screen_type !== event.target.value;
      if (mode === "new") {
        artboardSpec.screen_type = event.target.value;
        setDefaultDeviceSize(event, reset);
        isEligible = checkEligibility();
      } else if (mode === "edit") {
        updateArtboard(event, "screen_type", $activeSpec);
      }
    }}
  />
  {#if mode !== "new"}
    <p class="text-sm mb-2">Device type can't be changed.</p>
  {/if}
</div>

{#if $viewSpecs[0]}
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row form-inline">
      <Label for="lock_aspect_ratio">Maintain the aspect ratio</Label>
      <Input
        type="checkbox"
        name="lock_aspect_ratio"
        id="lock_aspect_ratio"
        class="ms-2"
        bind:checked={lock_aspect_ratio}
        on:change={(event) => {
          lock_aspect_ratio = event.target.checked;
          if (artboardSpec.screen_type) updateAspecRatio();
        }}
      />
    </div>
  </div>
{/if}

<div class="pane-divider" style="height: 0.75rem; margin-bottom: 1rem">
  <button
    class="advancedButton"
    on:click={() => {
      advanced = !advanced;
    }}><i class={`bi bi-${advanced ? "caret-down-fill" : "caret-right"} me-1`}></i>Advancded</button
  >
</div>

<Collapse isOpen={advanced}>
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="artboard_width"
      title="Artboard Width"
      value={artboardSpec.artboard_width || ""}
      {inputBlurAction}
      {inputFocusAction}
      changeAction={(event) => {
        if (mode === "new") {
          artboardSpec.artboard_width = parseInt(event.target.value);
        } else if (mode === "edit") {
          updateArtboard(event, "artboard_width", $activeSpec);
        }
        isEligible = checkEligibility();
      }}
    />
  </div>

  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="artboard_height"
      title="Artboard Height"
      value={artboardSpec.artboard_height || ""}
      {inputBlurAction}
      {inputFocusAction}
      changeAction={(event) => {
        if (mode === "new") {
          artboardSpec.artboard_height = parseInt(event.target.value);
        } else if (mode === "edit") {
          updateArtboard(event, "artboard_height", $activeSpec);
        }
        isEligible = checkEligibility();
      }}
    />
  </div>

  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <p class="text-sm mb-2">
        Below will be automatically filled once you choose a device type.
      </p>
    </div>
  </div>

  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="device_width"
      title="Device Width"
      value={artboardSpec.device_width || ""}
      {inputBlurAction}
      {inputFocusAction}
      changeAction={(event) => {
        if (mode === "new") {
          artboardSpec.device_width = parseInt(event.target.value);
        } else if (mode === "edit") {
          updateArtboard(event, "device_width", $activeSpec);
        }
        isEligible = checkEligibility();
      }}
    />
  </div>

  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="device_height"
      title="Device Height"
      value={artboardSpec.device_height || ""}
      {inputBlurAction}
      {inputFocusAction}
      changeAction={(event) => {
        if (mode === "new") {
          artboardSpec.device_height = parseInt(event.target.value);
        } else if (mode === "edit") {
          updateArtboard(event, "device_height", $activeSpec);
        }
        isEligible = checkEligibility();
      }}
    />
  </div>

  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="number"
      token="ppi"
      title="Device PPI (pixel per inch)"
      value={artboardSpec.ppi || ""}
      {inputBlurAction}
      {inputFocusAction}
      changeAction={(event) => {
        if (mode === "new") {
          artboardSpec.ppi = parseInt(event.target.value);
        } else if (mode === "edit") {
          updateArtboard(event, "device_ppi", $activeSpec);
        }
        isEligible = checkEligibility();
      }}
    />
  </div>

  <div class="pane-divider" />
</Collapse>

<div class="dupo-menu-pane mt-5 mb-2">
  <div class="dupo-menu-pane-button-row">
    {#if mode === "new"}
      <button
        type="button"
        disabled={!isEligible}
        on:click={() => {
          makeNewArtboard(artboardSpec);
        }}><i class="bi bi-plus-circle me-1" />Create</button
      >
    {/if}
    <button
      type="button"
      on:click={() => {
        if ($directContext) currMenu.set("selection");
        else {
          cancelSubMenu();
          unfindView();
        }
      }}><i class="bi bi-arrow-left me-1" />Go back</button
    >
  </div>
</div>

<style>
  .advancedButton {
    appearance: none;
    margin: 0;
    border: 0;
    padding: 0 0.5rem 0 0.5rem;
    background-color: #f3f3f3;
    font-size: 0.8rem;
  }
</style>
